import { render, staticRenderFns } from "./SonarFormContent.vue?vue&type=template&id=6027a910"
import script from "./SonarFormContent.vue?vue&type=script&lang=js"
export * from "./SonarFormContent.vue?vue&type=script&lang=js"
import style0 from "./SonarFormContent.vue?vue&type=style&index=0&id=6027a910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports